import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import { useBodyOverflowHidden } from 'hooks';
import styles from './Backdrop.module.scss';

export interface IBackdrop extends HTMLAttributes<HTMLDivElement> {
  open: boolean;
  onClose: () => void;
}

const Backdrop: FC<IBackdrop> = (props) => {
  const { open, onClose = () => {}, className, children } = props;
  const rootClassName = classNames(styles.root, className);

  useBodyOverflowHidden(open);

  if (!open) return null;

  return (
    <div className={rootClassName} onMouseDown={onClose} role='presentation'>
      {children}
    </div>
  );
};

export default Backdrop;
